import { render, staticRenderFns } from "./SEOStructuredData.vue?vue&type=template&id=e4e4b530"
import script from "./SEOStructuredData.vue?vue&type=script&lang=js"
export * from "./SEOStructuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports